import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import BottomMenuBar from "../../Components/BottomMenuBar";
import TopMenubar from "../../Components/TopMenubar";
import { toggleMobileMenu, toggleOffcanvasStatus } from "../../Redux/Slices/ProjectSlice";
import Footer from "../Footer";


const Layout = () => {
  const { searchBoxStatus, isMobileMenuOpen, DarkTheme, offcanvasStatus, isJWT_TockenValid, isLoginUserValid } = useSelector((state) => state.ProjectSlice);
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
  // const isUserLoggedIn = Cookies?.get("LoggedInStatus") || null;

  
  useEffect(() => {
   

    const handleResize = () => {
      console.log("windowInnerwidth", window.innerWidth);
      setIsMobile(window.innerWidth < 1200);
      if (window.innerWidth < 1200) {
        dispatch(toggleOffcanvasStatus(false));
        dispatch(toggleMobileMenu(false));
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isMobile && isMobileMenuOpen && sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        dispatch(toggleMobileMenu(false));
        dispatch(toggleOffcanvasStatus(false));
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMobileMenuOpen, offcanvasStatus]);

  console.log("isTokenValidIsLoginUserValid", isJWT_TockenValid, isLoginUserValid);
  console.log("RenderedLayout>>>>>>>>>>>>");

  // useEffect(() => {
  //   console.log("IsJWttokenValie", isJWT_TockenValid)
  //   if (isJWT_TockenValid === null) {
  //     toast.dismiss();
  //     dispatch(handleLogout());
  //     notifyError("Your session has expired. Please log in again.");
  //   }
  // }, [isJWT_TockenValid]);

  // if (!isJWT_TockenValid) {
  //   return <Navigate to="/Splash" replace />;
  // }

  // if (!isJWT_TockenValid) {
  //   toast.dismiss();
  //   dispatch(handleLogout());
  //   notifyError("Your session has expired. Please log in again.");
  //   return <Navigate to={`/Splash`} />;
  // }

  // console.log("formikValuesValuesLayout", isLoginUserValid);

  // if (!isLoginUserValid) {
  //   console.log("LayoutRendered");
  //   dispatch(handleInvalidUser());
  //   return <UnAuthorizedUserPage />;
  // } else {
  //   dispatch(handleSetISLoggedIn(true));
  // }

  return (
    <div
      data-bs-theme={DarkTheme ? "dark" : null}
      className={`layout-wrapper layout-navbar-full layout-horizontal layout-without-menu  layout-transitioning  ${isMobileMenuOpen ? "layout-menu-expanded" : ""}`}
    >
      <div className="layout-container">
        {/* {!isUserLoggedIn ? <UnAuthorizedUserPage /> : <> */}
        <TopMenubar isMobile={isMobile} />
        <BottomMenuBar />
        <div className="layout-page">
          <div className="content-wrapper">
            <Outlet />
            <Footer />
            <div className={offcanvasStatus ? "offcanvas-backdrop fade show" : "content-backdrop fade"} />
          </div>
        </div>
        {/* </>} */}
      </div>
    </div>
  );
};

export default Layout;
